exports.save = function (state, doc) {
  return state.routesDB.put(doc)
    .then(response => {
      return Object.assign({}, doc, {
        _rev: response.rev
      })
    })
}
